<template>
  <v-card :flat="true" class="d-flex flex-column">
    <v-card-text>
      <div>{{ $t("strings.select-location-info") }}</div>
      <div id="map" class="mb-2"></div>
      <v-row class="mt-2">
        <v-col cols="6" sm="12" md="6">
          <v-text-field
            name="latitude"
            v-model="geolocation.latitude"
            :label="$t('labels.latitude')"
            variant="outlined"
            density="compact"
            @input="setCoordinates"
            maxlength="15"
            hide-details="auto"
            prepend-inner-icon="mdi-latitude"
            clearable
            placehodelder="51.505"
          ></v-text-field>
        </v-col>
        <v-col cols="6" sm="12" md="6">
          <v-text-field
            name="longitude"
            v-model="geolocation.longitude"
            :label="$t('labels.longitude')"
            variant="outlined"
            density="compact"
            @input="setCoordinates"
            maxlength="15"
            hide-details="auto"
            prepend-inner-icon="mdi-longitude"
            clearable
            placeholder="-0.09"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import mapMethods from "../mixins/mapMethods";
import utils from "../mixins/utils";

export default {
  mixins: [mapMethods, utils],
  props: ["parentGeolocation"],
  emits: ["updateGeolocation"],
  data() {
    return {
      map: null,
      marker: null,
      markerLayer: null,
      geolocation: {
        latitude: 0,
        longitude: 0,
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      // Wait for the DOM to be ready before initializing the map
      setTimeout(() => {
        this.initDialogMap();
      }, 100);
    });
  },
  watch: {
    parentGeolocation: {
      handler(newVal) {
        this.geolocation = JSON.parse(JSON.stringify(newVal));
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initDialogMap() {
      this.map = L.map("map");
      this.markerLayer = new L.LayerGroup();
      this.credentials.addTo(this.map);
      this.map.on("click", this.onMapClick);
      this.markerLayer.addTo(this.map);

      if (this.markerAlreadySet()) {
        this.geolocation = JSON.parse(JSON.stringify(this.parentGeolocation));
        this.setMapCentre(this.geolocation);
        this.setMarker(this.geolocation);
      } else {
        this.map.setView([51.505, -0.09], 3);
      }
    },

    onMapClick(e) {
      if (this.markerLayer.getLayers().length >= 1) {
        //delete previous markers
        this.markerLayer.clearLayers();
      }
      this.getLatLng(e);
    },

    getLatLng(e) {
      this.marker = L.marker(e.latlng, {
        icon: this.icon,
      }).addTo(this.markerLayer);

      this.geolocation.latitude = e.latlng.lat;
      this.geolocation.longitude = e.latlng.lng;

      this.$emit("updateGeolocation", this.geolocation);
      this.setMapCentre(this.geolocation);
    },

    setCoordinates() {
      const newCoordinates = this.formatGeolocation(this.geolocation);
      this.map.setView(
        L.latLng(newCoordinates.latitude, newCoordinates.longitude),
        3,
      );
      this.setMarker(newCoordinates);
      this.$emit("updateGeolocation", newCoordinates);
    },
    formatNumber(value) {
      if (typeof value !== "string") {
        value = value === null || value === undefined ? "0" : value.toString();
      }
      value = value.replace(/[^0-9.-]/g, "");
      value = value.replace(/(?!^)-/g, "");
      value = value.replace(/(\..*)\./g, "$1");
      return value;
    },

    formatGeolocation(geolocation) {
      return {
        latitude: this.checkIntegrity(
          this.formatNumber(geolocation.latitude) || "51.505",
        ),
        longitude: this.checkIntegrity(
          this.formatNumber(geolocation.longitude) || "-0.09",
        ),
      };
    },

    checkIntegrity(value) {
      if (value === "" || value === "-" || value === ".") {
        return "";
      }
      return parseFloat(value);
    },

    markerAlreadySet() {
      return (
        this.parentGeolocation.latitude !== "" &&
        this.parentGeolocation.longitude !== ""
      );
    },
  },
};
</script>

<style scoped>
#map {
  width: 100%;
  height: 50vh;
  position: relative;
}
</style>
